/* File : src/routes/index.js */
import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useParams, useNavigate } from 'react-router-dom';
import { EventProvider } from '../contexts/EventContext';

// Pages invités
import HomePage from '../pages/GuestPages/HomePage';
import CitySelectionPage from '../pages/GuestPages/CitySelectionPage';
import EventPage from '../pages/GuestPages/EventPage';
import RegistrationPage from '../pages/GuestPages/RegistrationPage';
import TicketPage from '../pages/GuestPages/TicketPage';
import RetrieveTicketPage from '../pages/GuestPages/RetrieveTicketPage';

// Page du scanner - accès direct
import ScannerPage from '../pages/ScannerPage/ScannerPage';

// Composant pour extraire l'ID d'événement de l'URL (legacy support)
const EventRedirect = () => {
  const navigate = useNavigate();
  
  // Rediriger directement vers la page d'accueil - l'événement sera récupéré automatiquement
  React.useEffect(() => {
    navigate('/');
  }, [navigate]);
  
  return <div>Redirection...</div>;
};

// Wrapper pour les pages qui nécessitent le contexte d'événement
const EventContextWrapper = ({ children }) => (
  <EventProvider>
    {children}
  </EventProvider>
);

const AppRoutes = () => {
  return (
    <Router basename="/brightbar">
      <Routes>
        {/* Route d'accueil - vérification d'âge */}
        <Route path="/" element={<HomePage />} />
        
        {/* Route de sélection de ville */}
        <Route path="/city-selection" element={
          <EventContextWrapper>
            <CitySelectionPage />
          </EventContextWrapper>
        } />
        
        {/* Routes après vérification d'âge, avec contexte d'événement */}
        <Route path="/event" element={
          <EventContextWrapper>
            <EventPage />
          </EventContextWrapper>
        } />
        
        <Route path="/register" element={
          <EventContextWrapper>
            <RegistrationPage />
          </EventContextWrapper>
        } />
        
        <Route path="/ticket/:phone" element={
          <EventContextWrapper>
            <TicketPage />
          </EventContextWrapper>
        } />
        
        {/* Page de récupération de ticket */}
        <Route path="/retrieve-ticket" element={
          <EventContextWrapper>
            <RetrieveTicketPage />
          </EventContextWrapper>
        } />
        
        {/* Support des anciennes URLs avec ID d'événement (redirection) */}
        <Route path="/events/:eventId" element={<EventRedirect />} />
        
        {/* Scanner */}
        <Route path="/scanner" element={<ScannerPage />} />
        
        {/* Redirection par défaut */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;